import { Heading, Modal, theme, Warning } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import TrashcanIcon from '@lmc/ui-kit/src/general/Icon/customShapes/Trashcan'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import { postJSON } from 'common/services/api'
import { showToast } from 'common/utils'
import { NAMESPACE } from 'locale'
import { toDosConstants } from 'locale/toDos'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import styled from 'styled-components'

type DeleteRecurringTaskModalProps = {
  recurringTaskId: string
  isModalVisible: boolean
  setIsModalVisible: (val: boolean) => void
  refetch: () => void
}
export const DELETE_RECURRING_TASK = `/list/recurring-tasks/`

const DeleteRecurringTaskModal = ({
  recurringTaskId,
  isModalVisible,
  setIsModalVisible,
  refetch
}: DeleteRecurringTaskModalProps) => {
  const { t } = useTranslation(NAMESPACE.TODOS)

  const onDeleteSuccess = () => {
    showToast({ title: t(toDosConstants.TOAST_DELETE) })
  }

  const deleteFunction = () =>
    postJSON({
      url: `${DELETE_RECURRING_TASK}${recurringTaskId}`,
      method: 'DELETE'
    })

  const { mutateAsync: deleteMutation } = useMutation(
    [`delete-recurring-task-${recurringTaskId}`],
    deleteFunction,
    {
      onSuccess: () => {
        onDeleteSuccess()
        refetch()
      }
    }
  )

  const handleDelete = () => {
    deleteMutation()
    setIsModalVisible(false)
  }
  return (
    <Modal
      closeButton
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      classicPadding
      width580px
      onConfirm={handleDelete}
      onCancel={() => setIsModalVisible(false)}
      localisation={{
        confirmText: t(toDosConstants.DELETE_SHORT),
        cancelText: t(toDosConstants.CANCEL)
      }}
      confirmButtonProps={{ variant: 'danger', icon: TrashcanIcon }}
    >
      <TitleContainer>
        <Warning size={24} color={theme.color.status.danger} />
        <Title level={3}>{t(toDosConstants.DELETE)}</Title>
      </TitleContainer>
      <Divider />
      <DescirptionContainer>
        <Text>{t(toDosConstants.DELETE_RECURRENCE_DESCRIPTION)}</Text>
      </DescirptionContainer>
      <Divider />
    </Modal>
  )
}
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
`
const Title = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3};
`

const DescirptionContainer = styled.div`
  padding: 24px 12px;
`

export default DeleteRecurringTaskModal
